export function WaveGreaterThan(
  wave: Wave2 | Wave2[] | undefined,
  waveToCompare: Wave2
) {
  // for undefined cases, never mostly
  if (!wave) {
    return false;
  }
  if (Array.isArray(wave)) {
    return wave.every((w) => w >= waveToCompare);
  } else {
    return wave >= waveToCompare;
  }
}
